import { IS_PROD } from '@/constants';
import { ReactNode, useEffect } from 'react';
import sensors from 'sa-sdk-javascript';

const AppSensors = ({ children }: { children: ReactNode }) => {
  // 埋点
  useEffect(() => {
    sensors.init({
      web_url: process.env.REACT_APP_BASE_SA,
      server_url: process.env.REACT_APP_BASE_SA,
      use_client_time: true,
      send_type: 'beacon',
      show_log: IS_PROD
    });
    sensors.registerPage({
      platform_type: 'PC', // 公众号，h5 都填写 H5
      project: 'tender-PC', // 项目名称
      pageArea: 'web', // 项目类型
      pageCountry: 'China', // 所在地区
      pageLanguage: 'zh-cn', // 语言
      pageIdentifier: 'tender-PC', // 项目名称
      pagePool: 'ZDP' // 部门
    });
    sensors.quick('autoTrack');
  }, []);

  return <>{children}</>;
};

export default AppSensors;
